export default {
  data() {
    return {

    }
  },
  watch: {
    //解决当前页最后一条删除后，没有自动折页的问题-因分页用的地方太多，混入监听
    totalCount() {
      const cPage = this.totalCount / this.search.pageSize;
      if (this.search.pageIndex === cPage + 1 && this.search.pageIndex != 1) {
        this.search.pageIndex = this.search.pageIndex - 1;
        this.getList(); //获取列表数据
      }
    },
    pageTotal() {
      const cPage = this.pageTotal / this.pageSize;
      if (this.pageNum === cPage + 1 && this.pageNum != 1) {
        this.pageNum = this.pageNum - 1;
        this.getList(); //获取列表数据
      }
    },
  },
  mounted() {},
  methods: {}
}